/* eslint-disable rxjs-angular/prefer-takeuntil */
import { LoginAnalyticsService } from '@account/effects';
import { State, getAccountId, loadUserInfo } from '@account/entity';
import type { OnInit } from '@angular/core';
import { Component, DestroyRef, inject } from '@angular/core';
import { myEnvironmentActive } from '@core/settings';
import { isNotNullish } from '@innogy/utils-rxjs';
import { Store, select } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
@Component({
  selector: 'wl-load-account',
  templateUrl: './load-account.component.html',
})
export class LoadAccountComponent implements OnInit {
  readonly #destroyRef = inject(DestroyRef);
  readonly #store$ = inject(Store<State>);
  readonly #loginAnalyticsService = inject(LoginAnalyticsService);

  private readonly myEnvironmentActive$ = this.#store$.pipe(
    select(myEnvironmentActive),
    filter((active) => active === true)
  );

  private readonly accountId$ = this.#store$.pipe(
    select(getAccountId),
    filter(isNotNullish)
  );

  private readonly trackLoginLastStep$ = this.accountId$.pipe(
    filter(() => this.#loginAnalyticsService.clearAuthTrackingCookies()),
    map((accountId) => this.#loginAnalyticsService.trackLogin(accountId)),
    take(1)
  );

  ngOnInit() {
    const loadUserInfo$ = this.myEnvironmentActive$.pipe(
      tap(() => this.#store$.dispatch(loadUserInfo()))
    );
    const trackLoginLaststep$ = this.myEnvironmentActive$.pipe(
      switchMap(() => this.trackLoginLastStep$)
    );

    const subscription = combineLatest([
      loadUserInfo$,
      trackLoginLaststep$,
    ]).subscribe();

    this.#destroyRef.onDestroy(() => subscription.unsubscribe());
  }
}
